import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig/index'
import CheckBoxInputAvtalTyp from '../Inputs/CheckBoxInputAvtalTyp'
import CheckBoxInputAvtalleverant from '../Inputs/CheckBoxInputAvtalleverant'
import CheckBoxInputAvtalStatus from '../Inputs/CheckBoxInputAvtalStatus'
import CheckBoxInputFakturaStatus from '../Inputs/CheckBoxInputFakturaStatus'
import CheckBoxInputWithLeventor from '../Inputs/CheckBoxInputWithLeventor'
import CheckBoxInputWithForlorad from '../Inputs/CheckBoxInputWithForlorad'
import IntlMessages from 'util/IntlMessages';
function AvtalSection(props) {

    const Flags = useSelector(state => state.accountsData.Flags) 
    const prospektAvtalFreeInputsList = useSelector(state => state.accountsData.prospektAvtalFreeInputsList) 

    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    return (<>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="AvtalId"  MetaN={"Avtal_ID"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAvtalTyp Meta="AvtalTyp" MetaN={"Avtal_Typ"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAvtalleverant Meta="Leverantör" MetaN={"Avtal_Leverantor"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ägare" MetaN={"Avtal_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Rubrik" MetaN={"Avtal_Rubrik"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Med löpande" MetaN={"Avtal_MLopande"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputWithLeventor Meta="Med leverantör" MetaN={"Avtal_Mleverantör"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputWithForlorad Meta="Med Förlorad" MetaN={"Avtal_Forlorad"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAvtalStatus Meta="Avtal status" MetaN={"Avtal_status"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            parseInt(Flags.Fortnox) === 1?
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputFakturaStatus Meta="Avtal fakturastatus" MetaN={"Avtal_fakturastatus"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
            :""
           }
             <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputTaggning Meta="Taggning" MetaN={"Avtal_Taggning"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
             <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Abonnemang" MetaN={"Avtal_Abonnemang"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Avtal TB" MetaN={"Avtal_TB"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Avtal Inpris" MetaN={"Avtal_Inpris"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Avtal Utpris" MetaN={"Avtal_Utpris"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Avtal TG" MetaN={"Avtal_TG"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            props.Chips.some(item=>item.MetaN === "Avtal_Abonnemang")?
            <>
            <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item className={"p-2"}  xs={12} ><IntlMessages id="Invoicing"/></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Avtalslängd" MetaN={"Avtal_Abonnemang_BillingLength"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Fakturaintervall" MetaN={"Avtal_Abonnemang_BillingIntervall"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Betalningsvillkor" MetaN={"Avtal_Abonnemang_termofPayment"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Abonnemang löpande" MetaN={"Avtal_Abonnemang_lopande"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Abonnemang status" MetaN={"Avtal_Abonnemang_status"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Abonnemang startdatum" MetaN={"Avtal_Abonnemang_skapaDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Abonnemang Periodstart" MetaN={"Avtal_Abonnemang_Periodstart"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Abonnemang Periodslut" MetaN={"Avtal_Abonnemang_Periodslut"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
            </>
            :""
           }
           
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>

           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Avtal skapa datum" MetaN={"Avtal_skapaDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6}>
           <CheckBoxDatum Meta="Avtal start datum" MetaN={"Avtal_startDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6}>
           <CheckBoxDatum Meta="Avtal omförhandling datum" MetaN={"Avtal_omforDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Avtal löper ut datum" MetaN={"Avtal_loperDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            parseInt(Flags.Fortnox) === 1?
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Faktura datum" MetaN={"Avtal_FakturaDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           :""
           }
           {
            parseInt(Flags.Fortnox) === 1?
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Betalatdatum" MetaN={"Avtal_BetaltDatum"}   disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           :""
           }
        <Grid item className={"p-2"}  xs={12} >
            <Divider/>
        </Grid>
        <Grid item style={{height:46}} className={"pt-1"}  xs={12} ><IntlMessages id="Free.Inputs"/> *<small>(max 10)</small></Grid>
        {
                !isEmpty(prospektAvtalFreeInputsList)?
                    !isEmpty(prospektAvtalFreeInputsList.filter(item=>item.inRapport === 1))?
                    prospektAvtalFreeInputsList.filter(item=>item.inRapport === 1).map(item=>{
                        return <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={6} lg={4} >
                        <CheckBoxInput Meta={item.Meta} MetaN={`Avtal_Free_Inputs_${item.Meta}`} 
                        disabled={
                            //
                            props.Chips.filter(item=>item.MetaN.includes("Avtal_Free_Inputs_")).length > 9?
                            props.Chips.some(itemdd=>itemdd.MetaN === `Avtal_Free_Inputs_${item.Meta}` )?false:true:
                            false
                        } 
                        Value={true} 
                        onChangeMstate={props.onChangeMstate} 
                        Mstate={props.Chips}
                        />
                        </Grid>
                    })
                    :""
                :""
            }
           </Grid>
        </>
    );
}

export default AvtalSection;